var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/nsips-relation-situations-list.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-436c69fd!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/nsips-relation-situations-list.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/NsipsRelationSituationList.vue
// module id = 330
// module chunks = 1